export const storeContestStatisticsOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  searchShow: false,
  searchBtn: false,
  refreshBtn: false,
  columnBtn: false,
  menu: false,
  addBtn: false,
  delBtn: false,
  editBtn: false,
  viewBtn: false,
  searchBtn: false,
  column: [
    {
      label: '总经理',
      prop: 'name',
      editDisabled: true,
    },
    {
      label: '已完赛人数',
      prop: 'attendeesCount',
      editDisabled: true,
    },
    {
      label: '平均分',
      prop: 'averageScore',
      editDisabled: true,
    },
  ]
}